var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "detail-info-comment" },
    [
      _c("j-editor", {
        attrs: {
          value: _vm.value,
          "upload-source": "ipsys",
          limit: 5000,
          height: 200
        }
      }),
      _c(
        "div",
        { staticClass: "detail-info-comment-btns" },
        [
          _c(
            "a-button",
            {
              attrs: { type: "primary", icon: "check" },
              on: { click: _vm.confirmClick }
            },
            [_vm._v(" " + _vm._s(_vm.confirmText) + " ")]
          ),
          _c(
            "a-button",
            {
              attrs: { icon: "close" },
              on: {
                click: function($event) {
                  return _vm.$emit("cancel")
                }
              }
            },
            [_vm._v(_vm._s(_vm.cancelText))]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }